<script lang="ts">
  import TextNew from "../TextNew.svelte";
  import { createModal, type ModalPartAttributes } from "../modals/createModal";
  import InstructionalModal from "../modals/InstructionalModal.svelte";
  import WhatsappContactCard from "../modals/WhatsappContactCard.svelte";
  import ModalInstructionsStepCard from "../modals/ModalInstructionsStepCard.svelte";
  import PosLink from "../gp/POSLink.svelte";
  import { createWhatsappSupportUrl } from "../../constants/url";
  import { t } from "../../helpers/translations";

  export let underlayAttrs: ModalPartAttributes;
  export let contentAttrs: ModalPartAttributes;
  export let open: boolean;
  export let contentAction: ReturnType<typeof createModal>["content"];

  const posLinks = [
    {
      name: "Square",
      link: "https://squareup.com/help/gb/en/article/5072-summaries-and-reports-from-the-online-dashboard#:~:text=Manage%20Reporting%20Email,Save%20when%20finished",
    },
    {
      name: "Lightspeed",
      link: "https://k-series-support.lightspeedhq.com/hc/en-us/articles/12285092786203-Automated-reporting-with-Lightspeed-Payments#:~:text=Log%20in%20to,Click%20Save%20reports",
    },
    {
      name: "EPOS",
      link: "https://support.eposnow.com/s/article/Dashboards-and-Scheduled-Emails?language=en_US#:~:text=top%20left%20corner).-,Scheduled%20emails,with%20the%20reporting%20data%2C%20based%20on%20the%20times%20you%20have%20set.,-United%20Kingdom",
    },
    {
      name: "Revel",
      link: "https://support.revelsystems.com/s/article/Auto-Delivery-of-Reports-1583149669622",
    },
    {
      name: "Toast",
      link: "https://central.toasttab.com/s/article/Contact-Settings-Email-List-Configuration-Nightly-Emails-1492812482238#:~:text=On/Off%20Notifications-,To%20start%20sending%20email%20notifications%20to%20your%20restaurant%20staff%2C%20first%2C%20create,Save%C2%A0your%20changes.,-If%20you%20ever",
    },
    {
      name: "using different POS system?",
      link: createWhatsappSupportUrl(
        "Hi, I need help with running a daily sales summary report from my POS system for the GP tracker in REKKI insights, could you help me with this?"
      ),
      color: "textLow" as const,
    },
  ];
</script>

<InstructionalModal
  {open}
  {underlayAttrs}
  {contentAttrs}
  {contentAction}
  backgroundImage="/static/assets/images/sales-import-modal-bg.png"
  aspectRatio="1.3"
>
  <div slot="leftPanel" class="modal-left">
    <div class="title">
      <TextNew weight="medium" size="xl" --rk-text-color="var(--rk-text-light)">
        {t("salesModal.main.title")}
      </TextNew>
    </div>
  </div>

  <div slot="rightPanel" class="modal-right">
    <ModalInstructionsStepCard step={1} title={t("salesModal.generate.title")} --pb="0px">
      <TextNew size="s" --rk-text-color="var(--rk-text-low)">
        {t("salesModal.generate.subtitle")}
      </TextNew>

      <div class="pos-list">
        {#each posLinks as pos (pos.name)}
          <PosLink name={pos.name} link={pos.link} color={pos.color} />
        {/each}
      </div>
    </ModalInstructionsStepCard>

    <ModalInstructionsStepCard step={2} title={t("salseModal.send.title")}>
      <TextNew size="s" --rk-text-color="var(--rk-text-low)">
        {t("salesModal.send.subtitle")}
      </TextNew>
    </ModalInstructionsStepCard>

    <WhatsappContactCard description={t("salesModal.help.subtitle")} />
  </div>
</InstructionalModal>

<style>
  .modal-left {
    flex: 0 1 400px;
    padding: 32px 24px;
    height: 100%;
  }

  .title {
    padding: 0px 8px;
  }

  .modal-right {
    flex: 0 1 560px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    height: 100%;
    overflow: auto;
  }

  .pos-list {
    margin-top: 16px;
  }
</style>
